import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';

import { useWeb3State } from '../../../hooks';
import { getTargetOrigin } from '../../../utils/window.util';

interface Params {
  path: string;
}

export const Mogie: FC = () => {
  const { walletDetails } = useWeb3State();
  const { path } = useParams<Params>();
  const [src, setSrc] = useState(process.env.REACT_APP_MOGIES_URL);
  const [frame, setFrame] = useState<Window>();
  const routerHistory = useHistory();

  const messageListener = useCallback(
    e => {
      if (
        e.data === '/mint' &&
        (/Android/i.exec(navigator.userAgent) ||
          /iPhone/i.exec(navigator.userAgent))
      ) {
        location.assign(getTargetOrigin() + '/mint');
      } else if (
        [
          '/',
          '/gallery',
          '/roadmap',
          '/utility',
          '/behindthescenes',
          '/mogieland',
          '/mint',
        ].includes(e.data) &&
        !location.href.includes(e.data)
      ) {
        routerHistory.push(`/platform/mogie${e.data}`);
      }
    },
    [routerHistory],
  );

  useEffect(() => {
    window.addEventListener('message', messageListener);

    return () => window.removeEventListener('message', messageListener);
  });

  useEffect(() => {
    window.addEventListener('DOMContentLoaded', () => {
      const iframe = document.getElementById('iframe') as HTMLIFrameElement;
      iframe.addEventListener('load', () => {
        if (iframe.contentWindow !== null) {
          setFrame(iframe.contentWindow);
        }
      });
    });
  }, []);

  useEffect(() => {
    if (!walletDetails.address || !frame) {
      return;
    }

    frame.postMessage(
      { type: 'ethAddress', address: walletDetails.address },
      getTargetOrigin(),
    );
  }, [walletDetails, frame]);

  useEffect(() => {
    setSrc(
      getTargetOrigin() +
        '/' +
        (path
          ? path +
            (window.location.href.split('#').length === 2
              ? `#${window.location.href.split('#')[1]}`
              : '')
          : ''),
    );
  }, [path]);

  return (
    <iframe
      title="Mogie"
      id="iframe"
      src={src}
      width="100%"
      height="100%"
      frameBorder="0"
    ></iframe>
  );
};
